import { Col, Divider, Form, Row, Select, Typography } from "antd"
import React from "react"

import { PhoneInput } from "../../../../../components/PhoneInputs/PhoneInput.tsx"
import { DocumentCard } from "../../../../../components/Proposal&Contracts/DocumentCard.tsx"
import { placeholders } from "../../../../../constants/placeholders"
import { normalizeEmail } from "../../../../../utils/form/normalizeEmail.tsx"
import { validatePhone } from "../../../../../utils/validation/validate-phone.ts"
import { zipCodeRegexUS } from "../../../../../utils/validation/zip-code.ts"
import { contractFilterOptions } from "../../../constants/contract-filter-options.ts"
import { type ContractFormData } from "../contract-form-data.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

const { Title } = Typography

export function ContractClientInformationSection() {
  const key: keyof ContractFormData = "customer"

  return (
    <DocumentCard title={"Client Information"} name={key}>
      <Row gutter={[12, 0]}>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "first_name"]}
            label="First Name"
          >
            <TextInput placeholder="Enter first name" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "middle_name"]}
            label="Middle Name"
          >
            <TextInput placeholder="Enter middle name" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "last_name"]}
            label="Last Name"
          >
            <TextInput placeholder="Enter last name" />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "email"]}
            label="Email"
            rules={[
              { type: "email", message: "The email you entered is incorrect" }
            ]}
            normalize={normalizeEmail}
          >
            <TextInput disableAutoCapitalize placeholder={placeholders.email} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "phone"]}
            label="Phone"
            rules={[{ required: false, validator: validatePhone }]}
          >
            <PhoneInput />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "phone_2"]}
            label="Phone 2"
            rules={[{ required: false, validator: validatePhone }]}
          >
            <PhoneInput />
          </Form.Item>
        </Col>
      </Row>

      <div className={"pt-2"}>
        <Title level={4}>Property Information</Title>
        <Divider size={"small"} />
      </div>

      <Row gutter={[12, 0]}>
        <Col span={12}>
          <Form.Item<ContractFormData> name={[key, "address"]} label="Address">
            <TextInput placeholder="Enter address" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item<ContractFormData>
            name={[key, "address_2"]}
            label="Address 2"
          >
            <TextInput placeholder="Enter address" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData> name={[key, "city"]} label="City">
            <TextInput placeholder="Enter city" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData> name={[key, "state"]} label="State">
            <Select
              allowClear
              placeholder={"Enter state"}
              options={contractFilterOptions.state}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input?.toLowerCase())
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "zip_code"]}
            label="Zip Code"
            rules={[
              {
                required: false,
                pattern: zipCodeRegexUS,
                message: "Invalid postal code format"
              }
            ]}
          >
            <TextInput disableAutoCapitalize placeholder={placeholders.zipCode} />
          </Form.Item>
        </Col>
      </Row>
    </DocumentCard>
  )
}
